import {AsyncStatus} from 'enums';
import {IDeviceModel, IManufacturer} from 'interfaces';
// Not using index import for services to avoid circular dependency
import {axiosAPI} from './API';

export interface IPayloadRequest {
    s3Url: string,
    updateType: string,
    userDefined?: {[key: string]: string},
    version: string,
}

export interface IPayloadResponse {
    payload: any,
}

// Singleton for interacting with manufacturers
class _PayloadService {
    public generatePayload(request: IPayloadRequest): Promise<IPayloadResponse> {
        const p = axiosAPI.post<IPayloadResponse>('/payload', request)
            .then(response => response.data);
        
        // Doing a separate catch to avoid stopping the error from going up the chain.
        p.catch((err) => {
            console.error('Error generating payload: ', err);
        });

        return p;
    }
}

export const PayloadService = new _PayloadService();